function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M-75.632 35.901c26.449-62.898 37.367-25.136 89.68-19.822 42.839 4.351 75.455-8.256 146.98-8.256 57.028 0 96.29 10.745 122.067 12.607C324.497 23.42 350 7.823 350 7.823l-3.121 1018.297S268.427 1063 148.999 1063s-206.375-55.07-206.375-55.07S-102.08 98.8-75.632 35.901z",
  fill: "#FFF5F4"
});

function SvgCarePrinciplesBackgroundMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 1063,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIwIiBoZWlnaHQ9IjEwNjMiIHZpZXdCb3g9IjAgMCAzMjAgMTA2MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0tNzUuNjMyNCAzNS45MDFDLTQ5LjE4MzUgLTI2Ljk5NzQgLTM4LjI2NTUgMTAuNzY1MSAxNC4wNDc2IDE2LjA3ODdDNTYuODg2OCAyMC40MyA4OS41MDI3IDcuODIzMzMgMTYxLjAyOCA3LjgyMzMzQzIxOC4wNTYgNy44MjMzMyAyNTcuMzE4IDE4LjU2ODIgMjgzLjA5NSAyMC40M0MzMjQuNDk3IDIzLjQyMDUgMzUwIDcuODIzMzMgMzUwIDcuODIzMzNMMzQ2Ljg3OSAxMDI2LjEyQzM0Ni44NzkgMTAyNi4xMiAyNjguNDI3IDEwNjMgMTQ4Ljk5OSAxMDYzQzI5LjU3MTQgMTA2MyAtNTcuMzc1OSAxMDA3LjkzIC01Ny4zNzU5IDEwMDcuOTNDLTU3LjM3NTkgMTAwNy45MyAtMTAyLjA4MSA5OC43OTk0IC03NS42MzI0IDM1LjkwMVoiIGZpbGw9IiNGRkY1RjQiLz4KPC9zdmc+Cg==";
export { SvgCarePrinciplesBackgroundMobile as ReactComponent };